import lazyLoad from 'core/util/lazyLoad';

const AlertingSiteHealthMap = lazyLoad(() => import('./AlertingSiteHealthMap'));

export default AlertingSiteHealthMap;
